import Checkbox from 'semantic-ui-react/dist/es/modules/Checkbox';
import './Checkbox.css';

export default Checkbox;
